import { createContext } from 'react'

import { WorkspacePrebidConfigurationContextType } from './types'

export const WorkspacePrebidConfigurationContext =
  createContext<WorkspacePrebidConfigurationContextType>(
    {} as WorkspacePrebidConfigurationContextType,
  )
